import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {LovListModelModel} from "../lovListModel.model";
import {ValueAndLabelConverter} from "../../../../../converter/ValueAndLabel.converter";

export class LovListModelConverter extends HttpModelConverter<LovListModelModel> {

    protected createInstance(): LovListModelModel {
        return new LovListModelModel();
    }

    protected enrichObject(result: LovListModelModel, src: LovListModelModel) {
        result.paramType = new ValueAndLabelConverter().convert(src.paramType);
    }
}